var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('vs-button',{staticClass:"ml-auto mt-2",attrs:{"href":_vm.blogURL,"target":"_blog"}},[_vm._v("Manage Blog")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }